import { TreeItem } from "./tree-item.js";
import { TreeItemStyles, TreeItemTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system";
/**
 * The Fabric TreeItem component.
 *
 * @public
 */
export const definition = TreeItem.compose({
    name: `${DesignSystem.prefix}-tree-item`,
    template: TreeItemTemplate,
    styles: TreeItemStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=tree-item.definition.js.map